import { EspacioCurricularPciI } from "interfaces/EspacioCurricularPci";
import { AreaI } from "interfaces/Area";
import { TipoEspacioI } from "interfaces/TipoEspacio";

export interface infoFetchGetEspacioCurricularPciI {
  id: number | string;
  nombre: string;
  carga_horaria: number;
  cuatrimestre?: number | null;
  detalle_modificacion: string;
  anio: number;
  id_espacio_base?: number;
  area: AreaI;
  tipoEspacio: TipoEspacioI;
}

class EspacioCurricularPci implements EspacioCurricularPciI {
  id: number | string;
  nombre: string;
  carga_horaria: number;
  cuatrimestre: number | null;
  detalle_modificacion: string;
  anio: number;
  id_espacio_base?: number;
  area: AreaI;
  tipoEspacio: TipoEspacioI;

  constructor(infoFetch: infoFetchGetEspacioCurricularPciI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
    this.carga_horaria = infoFetch.carga_horaria;
    this.cuatrimestre = infoFetch.cuatrimestre ?? null;
    this.detalle_modificacion = infoFetch.detalle_modificacion;
    this.anio = infoFetch.anio;
    this.id_espacio_base = infoFetch.id_espacio_base;
    this.area = infoFetch.area;
    this.tipoEspacio = infoFetch.tipoEspacio;
  }
}

export const makeEspacioCurricularPci = (
  infoFetch: infoFetchGetEspacioCurricularPciI,
) => {
  return new EspacioCurricularPci(infoFetch);
};
